import { RunState } from "../state/RunState";
import { EMA } from "../utils/EMA";
import { clamp } from "../utils/Geometry";
import {
  BASE_POINT,
  SPEED_FACTOR_REFERENCE_MS,
  SPEED_FACTOR_MIN,
  SPEED_FACTOR_MAX,
} from "../app/Config";

export class ScoreSystem {
  private emaDelta: EMA;

  constructor(emaDelta: EMA) {
    this.emaDelta = emaDelta;
  }

  calculateAndApply(
    state: RunState,
    dist: number,
    targetRadius: number,
    nowMs: number
  ): number {
    // combo
    state.combo += 1;
    state.hits += 1;
    state.lastActivityTimeMs = nowMs;

    // speedFactor
    let speedFactor = 1.0;
    if (state.lastHitTimeMs > 0) {
      const deltaMs = nowMs - state.lastHitTimeMs;
      const emaVal = this.emaDelta.update(deltaMs);
      speedFactor = clamp(
        SPEED_FACTOR_REFERENCE_MS / emaVal,
        SPEED_FACTOR_MIN,
        SPEED_FACTOR_MAX
      );
    }
    state.lastHitTimeMs = nowMs;

    // accuracyFactor
    const normDist = clamp(dist / targetRadius, 0, 1);
    let accuracyFactor: number;
    if (normDist <= 0.2) accuracyFactor = 1.3;
    else if (normDist <= 0.45) accuracyFactor = 1.1;
    else if (normDist <= 0.75) accuracyFactor = 1.0;
    else accuracyFactor = 0.9;

    // comboMultiplier
    const comboMultiplier =
      1 + Math.min(2.5, Math.pow(state.combo - 1, 0.85) * 0.25);

    // stageFactor
    const stageFactor = 1 + Math.min(0.3, state.stageIndex * 0.03);

    const addScore = Math.round(
      BASE_POINT * comboMultiplier * speedFactor * accuracyFactor * stageFactor
    );
    state.score += addScore;
    state.stageScore += addScore;

    return addScore;
  }
}
